import { Text } from '@applane/react-core-components';
import React from 'react';
import { ROUTES } from '../../Lib/constants';
import { BuyPlanScreen } from './Buy/Buy';
import vars from '../../theme/vars';
import { cancelButton, save } from '../../app-components';

const { headings } = vars;

export default {
  [ROUTES.buyPlan.name]: {
    screen: BuyPlanScreen,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Subscription Plan</Text>
    ),
    headerActions: [cancelButton, save],
  },
};
